import "@hotwired/turbo-rails"
import "./controllers"
import "jquery-jpostal-ja"
import "trix"
import "@rails/actiontext"
import $ from "jquery"
window.$ = $;